import Request from './type/Request';
import handleJsonFetchError from './handle-json-fetch-error';

type T = <R>(url: string, request: Request) => Promise<R>;

const f: T = async (url, request) => {
    const response = await handleJsonFetchError(await fetch(url, request));

    return response.json();
};

export default f;
